<template>
    <v-form v-model="form" ref="form_step_1">
        <contact-information :validation-id="v__validationId" class="mt-5" ></contact-information>
        <dates-of-rental :validation-id="v__validationId" class="mt-5"></dates-of-rental>
        <DeliveryBlock v-if="is_delivery" class="mt-5"></DeliveryBlock>
        <steps-navigation :errors="v__getErrors()" :back-button="false" @step-next="stepNext"></steps-navigation>
    </v-form>
</template>

<script>
import ValidatableComponent     from "../../../mixins/ValidatableComponent";
import reservation_form__fields from "../../../validation/fields/reservation_form__fields";
import reservation_form_with_location__rules from "../../../validation/scenarios/reservation_form_with_location__rules";
import reservation_form__rules  from "../../../validation/scenarios/reservation_form__rules";
import reservation_canadian_form__rules  from "../../../validation/scenarios/reservation_canadian_form__rules";
import reservation_ridesnow_form__rules  from "../../../validation/scenarios/reservation_ridesnow_form__rules";
import delivery_reservation_form__rules  from "../../../validation/scenarios/delivery_reservation_form__rules";
import delivery_reservation_canadian_form__rules  from "../../../validation/scenarios/delivery_reservation_canadian_form__rules";
import DatesOfRental            from "./step1/DatesOfRental";
import DeliveryBlock            from "./step1/DeliveryBlock";
import ContactInformation       from "./step1/ContactInformation";
import StepsNavigation          from "../../../components/partials/StepsNavigation";
import {mapActions}             from "vuex";
import StepperComponentMixin    from "../../../mixins/StepperComponentMixin";
import UiManagerMixin           from "../../../mixins/UiManagerMixin";

export default {

    name: "Step1",
    components: {StepsNavigation, ContactInformation, DatesOfRental, DeliveryBlock},
    mixins: [StepperComponentMixin,ValidatableComponent, UiManagerMixin],
    data: () => ({
        form: false,
    }),
    methods: {
        ...mapActions(['do_save_reservation']),
        async stepSubmit() {
            if(!parseInt(this.$store.state.resources.config.reservee_gender)){
                this.$store.commit('set_model_value',{path:'model.reservation.gender_is_on',value: 0})
            }
            if(!this.is_delivery){
                this.$store.commit('set_model_value',{path:'model.reservation.pickup_hour',value: '12:00:00'})
            }
            try {
                const result = await this.do_save_reservation();

                return  true;
            } catch (e) {
                if (e.isCustomError) {
                    switch (e.type) {
                        case 'validation':
                            for (let attr in e.data.errors) {
                                this.addErrors(e.data.errors[attr].map(e => ({attr,message:e})));
                            }
                            break;
                    }
                }
                // console.log(e);
            }
            return false;
        },
    },
    computed : {
        useCoupons() {
            return this.$store.state.resources.config.use_coupons;
        },
        return_customer_advance() {
            return parseInt(this.$store.state.resources.config.return_customer_advance);
        },
        delivery(){
            return parseInt(this.$store.state.resources.config.delivery);
        },
        is_delivery() {
            return this.$store.state.model.reservation.is_delivery;
        },
        welcome_text_in_advance() {
            return parseInt(this.$store.state.resources.config.welcome_text_in_advance);
        }
    },
    mounted() {
        // Function to get the value of a specific cookie by its name
        const getCookie = (name) => {
            const cookies = document.cookie.split(';');
            for (let i = 0; i < cookies.length; i++) {
                const cookie = cookies[i].trim();
                // Check if this cookie has the name we're looking for
                if (cookie.startsWith(name + '=')) {
                    // Extract and return the cookie value
                    return cookie.substring(name.length + 1);
                }
            }
            return null; // Cookie not found
        };

        // Example: Get the value of a cookie named "myCookie"
        let grouplink_id = getCookie('grouplink_id');
        if( grouplink_id !== null ){
            this.$store.state.model.reservation.group_link_id = 1;
        }
        if(this.return_customer_advance && grouplink_id == null){
            this.ui__openModalByName({name:'dialog_return_customer'})
        }
        if(this.welcome_text_in_advance){
            this.ui__openModalByName({name:'dialog_welcome_text'})
        }
        const self = this;
        this.withValidation({
            getModel() {
                return self.$store.state.model.reservation;
            },
            rules : this.is_delivery?(parseInt(this.$store.state.resources.config.is_international_canadian)?delivery_reservation_canadian_form__rules:delivery_reservation_form__rules):
                (this.$store.state.resources.config.frontend_view_folder=='frontend.ridesnow' && parseInt(this.$store.state.resources.config.pickup_day_before)) || (this.$store.state.resources.config.frontend_view_folder=="frontend.backcountrysafary" && !window.location.href.includes("delivery"))? reservation_ridesnow_form__rules:
                    (parseInt(this.$store.state.resources.config.is_international_canadian)?reservation_canadian_form__rules:
                        this.$store.state.resources.config.frontend_view_folder=="frontend.adventure"? reservation_form_with_location__rules : reservation_form__rules),
            fields: reservation_form__fields
        })
    }

}
</script>

<style scoped>

</style>
